import { useCartContext } from "app/providers/CartProvider";
import { useMemo } from "react";
import { OrderProduct, Product } from "shared/api/middleware-api-client";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import { getProductExtraOptionNames } from "entities/configurator/model/extraOptionDisplay";

interface ProductItemConfigTableProps {
  product: Product | OrderProduct;
  className?: string;
}

const ProductItemConfigTable = ({
  product,
  className = "",
}: ProductItemConfigTableProps) => {
  const doorLayoutName = useMemo(() => {
    if ("doorLayout" in product) {
      return product.doorLayout.name;
    }
    return product.layoutOption;
  }, [product]);
  const doorColorName = useMemo(() => {
    if ("doorColor" in product) {
      return product.doorColor.name;
    }
    return product.colorOption;
  }, [product]);
  const doorGlassName = useMemo(() => {
    if ("doorColor" in product) {
      return product.glassType.name;
    }
    return product.glassOption;
  }, [product]);
  const doorHandleName = useMemo(() => {
    if ("doorColor" in product) {
      return product.doorHandle.name;
    }
    return product.handleOption;
  }, [product]);

  const doorExtraOptions = getProductExtraOptionNames(product);
  const showDoorExtraOptions = doorExtraOptions.length > 0;

  const { isSampleSale, getCart } = useCartContext();
  const cart = getCart();

  const showMontageWijzeText = !cart.sampleSale;
  return (
    <div className={`gg-mt-3 gg-pr-5 gg-text-sm lg:gg-mt-0.5 ${className}`}>
      <section className="gg-grid gg-w-full gg-gap-y-1 sm:gg-gap-y-1.5 md:gg-gap-y-2">
        {showMontageWijzeText && (
          <div className="gg-grid gg-grid-cols-2">
            <Heading headingLevel="h6" className="gg-font-bold">
              Montagewijze
            </Heading>
            <Text
              data-testid="montage-option"
              className="gg-text-right lg:gg-text-start"
            >
              {cart.isSelfAssembly
                ? "Zelf monteren"
                : "Montageservice door GewoonGers"}
            </Text>
          </div>
        )}

        <div className="gg-grid gg-grid-cols-2">
          <Heading headingLevel="h6" className="gg-font-bold">
            Ontwerp
          </Heading>
          <Text className="gg-text-right lg:gg-text-start">
            {doorLayoutName}
          </Text>
        </div>

        <div className="gg-grid gg-grid-cols-2">
          <Heading headingLevel="h6" className="gg-font-bold">
            Frame
          </Heading>
          <Text className="gg-text-right lg:gg-text-start">
            {doorColorName}
          </Text>
        </div>

        <div className="gg-grid gg-grid-cols-2">
          <Heading headingLevel="h6" className="gg-font-bold">
            Glas
          </Heading>
          <Text className="gg-text-right lg:gg-text-start">
            {doorGlassName}
          </Text>
        </div>

        <div className="gg-grid gg-grid-cols-2">
          <Heading headingLevel="h6" className="gg-font-bold">
            Deurbeslag
          </Heading>
          <Text className="gg-text-right lg:gg-text-start">
            {doorHandleName}
          </Text>
        </div>

        {showDoorExtraOptions && (
          <div className="gg-grid gg-grid-cols-2">
            <Heading headingLevel="h6" className="gg-font-bold">
              Extra opties
            </Heading>
            <ul className="gg-space-y-1 gg-text-right lg:gg-text-start">
              {doorExtraOptions.map((name) => (
                <li key={name}>
                  <Text>{name}</Text>
                </li>
              ))}
            </ul>
          </div>
        )}
      </section>

      {isSampleSale && (
        <section className="gg-grid gg-w-full gg-gap-y-1 gg-pt-2 sm:gg-gap-y-1.5 md:gg-gap-y-2">
          <div className="gg-grid gg-grid-cols-2">
            <Heading headingLevel="h6" className="gg-font-bold">
              Sample sale nummer
            </Heading>
            <Text className="gg-text-right lg:gg-text-start">
              {cart.sampleSaleReferenceNumber}
            </Text>
          </div>
          <div className="gg-grid gg-grid-cols-2">
            <Heading headingLevel="h6" className="gg-font-bold">
              Draairichting
            </Heading>
            <Text className="gg-text-right lg:gg-text-start">
              {cart.sampleSaleRotation}
            </Text>
          </div>

          <div className="gg-grid gg-grid-cols-2">
            <Heading headingLevel="h6" className="gg-font-bold">
              Afmetingen product
            </Heading>
            <Text className="gg-text-right lg:gg-text-start">
              {cart.sampleSaleMeasurement}
            </Text>
          </div>

          <div className="gg-grid gg-grid-cols-2">
            <Heading headingLevel="h6" className="gg-font-bold">
              Benodigde sponningsmaat
            </Heading>
            <Text className="gg-text-right lg:gg-text-start">
              {cart.sampleSaleRabbetSize}
            </Text>
          </div>
        </section>
      )}
    </div>
  );
};
export default ProductItemConfigTable;
